module.exports = __webpack_public_path__ + "1502693fc15c7174de5ebeff1534713a.jpg";